import { useMemo } from 'react';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import AssetActionsDropdown from 'asset-actions-lib/components/AssetActionsDropdown';
import AssetActionsProvider from 'asset-actions-lib/context/AssetActionsContext';
import AssetActionButton from './AssetActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DetailActionsContent({
  actionIdsToExclude,
  primaryActionId,
  secondaryActionId
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AssetActionButton, {
      actionId: secondaryActionId,
      "data-test-id": "secondary-action-button"
    }), /*#__PURE__*/_jsx(AssetActionsDropdown, {
      actionIdsToExclude: actionIdsToExclude,
      buttonUse: "secondary"
    }), /*#__PURE__*/_jsx(AssetActionButton, {
      actionId: primaryActionId,
      "data-test-id": "primary-action-button",
      use: "primary"
    })]
  });
}
function HoverActionsContent({
  actionIdsToExclude,
  primaryActionId,
  secondaryActionId
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AssetActionButton, {
      actionId: primaryActionId,
      "data-test-id": "primary-action-button"
    }), /*#__PURE__*/_jsx(AssetActionButton, {
      actionId: secondaryActionId,
      "data-test-id": "secondary-action-button"
    }), /*#__PURE__*/_jsx(AssetActionsDropdown, {
      actionIdsToExclude: actionIdsToExclude
    })]
  });
}
function EditorActionsContent({
  actionIdsToExclude,
  primaryActionId,
  secondaryActionId
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AssetActionButton, {
      actionId: primaryActionId,
      "data-test-id": "primary-action-button"
    }), /*#__PURE__*/_jsx(AssetActionButton, {
      actionId: secondaryActionId,
      "data-test-id": "secondary-action-button"
    }), /*#__PURE__*/_jsx(AssetActionsDropdown, {
      actionIdsToExclude: actionIdsToExclude
    })]
  });
}
export default function AssetActionsButtonLayoutWithProvider({
  actions,
  actionsConfigOverrides,
  crmObject,
  nonCrmObject,
  onActionError,
  onActionSuccess,
  primaryActionId,
  secondaryActionId,
  trackerProps,
  layoutUse = 'detail-actions'
}) {
  const actionIdsToExclude = useMemo(() => [primaryActionId || '', secondaryActionId || ''].filter(Boolean), [primaryActionId, secondaryActionId]);
  return /*#__PURE__*/_jsx(AssetActionsProvider, {
    actions: actions,
    actionsConfigOverrides: actionsConfigOverrides,
    crmObject: crmObject,
    layoutUse: layoutUse,
    nonCrmObject: nonCrmObject,
    onActionError: onActionError,
    onActionSuccess: onActionSuccess,
    trackerProps: trackerProps,
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      "data-test-id": "asset-actions-buttons-layout",
      children: [layoutUse === 'detail-actions' && /*#__PURE__*/_jsx(DetailActionsContent, {
        actionIdsToExclude: actionIdsToExclude,
        primaryActionId: primaryActionId,
        secondaryActionId: secondaryActionId
      }), layoutUse === 'hover-actions' && /*#__PURE__*/_jsx(HoverActionsContent, {
        actionIdsToExclude: actionIdsToExclude,
        primaryActionId: primaryActionId,
        secondaryActionId: secondaryActionId
      }), layoutUse === 'editor-actions' && /*#__PURE__*/_jsx(EditorActionsContent, {
        actionIdsToExclude: actionIdsToExclude,
        primaryActionId: primaryActionId,
        secondaryActionId: secondaryActionId
      })]
    })
  });
}